import cs from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Button, Popup, Tabs, Toast } from 'zarm';
import { Promise } from 'core-js';
import { CLAUSE_CHECKED } from '@/constants';
import { isPreviewMode } from '@/utils/tool';
import session from '@/store/session';
import { dispatch } from '@/store';
import ConfirmTip from '../confirmTip';
import BubbleTip from '../popupBubble';
import TabContent from '../tabContent';
import TabList from '../tabList';
import './index.less';
import CountDownBtn from './CountDownBtn';
const Title = styled.div`
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 45px;
`;

const useVisible = initialVisible => {
  const initShow = !isPreviewMode() && initialVisible; // const [visible, setVisible] = useCacheStateByPage('supervisionPopupVisible', initShow);

  const [visible, setVisible] = useState(initShow);
  return [visible, setVisible];
};

const {
  Panel
} = Tabs;
/**
 * 健康告知的弹出层
 * @param {*} param0
 */

const SupervisionPopup = props => {
  var _dataSource$value, _dataSource$value2, _dataSource$value3, _dataSource$value4;

  const {
    attrs = {},
    id
  } = props;
  const {
    buttonText = '',
    dataSource = [],
    visible = false
  } = attrs; // const moduleConfig = useCurrentModule();
  // 如果是tabs的情况，是否开启禁止所有tab，并点击按钮跳转到下一个tab

  const limitStep = true; // 默认开启点击按钮跳转到下一步，后续通过配置选择是否开启

  const [disabled, setDisabled] = useState(limitStep); // 同步组件内部的倒计时

  const [outerTime, setOuterTime] = useState(10);
  const [show, setShow] = useVisible(visible);
  const [value, setValue] = useState(0);
  const box = useRef();
  const countRef = useRef();
  const Pref = useRef({});
  const [isBottom, setIsBottom] = useState(false);
  const contentRef = useRef();

  const handleClose = () => {
    if (isPreviewMode()) {
      return;
    }

    setShow(false);
    session.set('supervisionPopupShow', false);
    session.set('supervisionPopupShowTab', false);
  };

  const updateToStore = () => {
    Pref.current.resolve(true);
    dispatch(CLAUSE_CHECKED, true);
    dispatch('supervisionBtnClicked', {
      clicked: true,
      supervisionTarget: 'supervision'
    });
  };

  const initTab = index => {
    const list = box.current;
    const tabs = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__tab');

    if (!list || !tabs) {
      return;
    }

    const scroll = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__scroll')[0];
    const ul = scroll === null || scroll === void 0 ? void 0 : scroll.getElementsByTagName('ul')[0];
    const curr = tabs[index];
    const currOb = curr === null || curr === void 0 ? void 0 : curr.getBoundingClientRect();
    const left = currOb.left - currOb.width / 2;

    if (ul) {
      ul.scrollTo({
        top: 0,
        left,
        behavior: 'smooth'
      });
    }
  };

  const changeTab = index => {
    const list = document.getElementsByClassName('popup-box')[0];
    const tabs = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__tab');
    const scroll = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__scroll')[0];
    const ul = scroll === null || scroll === void 0 ? void 0 : scroll.getElementsByTagName('ul')[0];
    const curr = tabs[index];
    const first = tabs[0];
    const currOb = curr === null || curr === void 0 ? void 0 : curr.getBoundingClientRect();
    const ulOb = ul === null || ul === void 0 ? void 0 : ul.getBoundingClientRect();
    const firstOb = first === null || first === void 0 ? void 0 : first.getBoundingClientRect();
    const line = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__line')[0];
    const firstLeft = firstOb.x < 0 ? -firstOb.x : firstOb.x; // 自动将tab移动到屏幕中间

    const clientWidth = document.body.offsetWidth;
    const left = (clientWidth - currOb.width) / 2;
    const scrollDiv = document.getElementsByClassName('za-tabs__tablist')[0];
    const scrollLeft = firstLeft + currOb.x;
    scrollDiv.scrollLeft = scrollLeft - left;
    line.style = '';
    line.style.display = 'none';
    setTimeout(() => {
      line.style.width = `${currOb.width * 4 / 4}px`;
      line.style.transform = '';
      line.style.display = 'block';
      line.style.position = 'absolute';
      line.style.left = `${firstLeft + currOb.x}px`;
    }, 100);
  }; // 返回true继续流程


  const btnClick = () => {
    if (isPreviewMode()) {
      return;
    } // 进行tabs的自动切换


    if (disabled) {
      // 最后一个tab页 只有一个tab页的时候回进入这种场景
      if ((dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) === value + 1 || !disabled) {
        updateToStore();
        setShow(false);
        return true;
      }

      if ((dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) === value + 2) {
        setDisabled(false);
      }

      setValue(value + 1);
      changeTab(value + 1);
    } else {
      // tab页阅读10秒以上
      if (dataSource.length > 1 && outerTime > 0) {
        Toast.show('请仔细阅读协议内容10s以上');
        return false;
      }

      updateToStore();
      setShow(false);
      return true;
    }
  };

  useEffect(() => {
    if (!isPreviewMode()) {
      const supervisionPopupShow = session.get('supervisionPopupShow');
      const supervisionPopupShowTab = session.get('supervisionPopupShowTab');

      if (supervisionPopupShow !== null) {
        setShow(supervisionPopupShow);
      }

      supervisionPopupShowTab && setValue(supervisionPopupShowTab);
    }

    dispatch('supervisionBtnClicked', {
      clicked: false,
      supervisionTarget: 'supervision'
    }); // 在store中保存这个弹出层模块的方法，供其他模块的button点击时做状态判断和操作

    dispatch('supervision', {
      isShow: () => show,
      show: () => {
        return new Promise((resolve, reject) => {
          Pref.current.resolve = resolve; // Pref.current.reject = reject;

          setShow(true);
        });
      },
      hide: handleClose,
      setTab: tabIndex => {
        if (Number(tabIndex) > dataSource.length) {
          setValue(0);
          return;
        }

        setValue(Number(tabIndex) - 1);
      }
    });
    dispatch('supervisionBtnClicked', {
      clicked: false,
      supervisionTarget: 'supervision'
    }); // }
    // 组件被卸载时候清除这个状态  防止在其他页面中止下一步流程

    return () => {
      dispatch('supervisionBtnClicked', {
        clicked: false,
        supervisionTarget: undefined
      });
    };
  }, []);
  useEffect(() => {
    setShow(visible);
  }, [visible]);
  useEffect(() => {
    if (isPreviewMode() || typeof show === 'undefined') {
      return;
    }

    if (show) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '0px';
      document.body.style.width = '100%';
    } else {
      document.documentElement.style.overflow = 'scroll';
      document.body.style.position = 'static';
    }

    return () => {
      document.documentElement.style.overflow = 'scroll';
      document.body.style.position = 'static';
    };
  }, [show]);
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        initTab(value);
        changeTab(value);
      }, 500);
    }
  }, [show]);
  useEffect(() => {
    setTimeout(() => {
      if (contentRef.current !== undefined && contentRef.current !== null) {
        const {
          className,
          offsetHeight,
          scrollTop,
          scrollHeight
        } = contentRef.current;

        if (offsetHeight + scrollTop > scrollHeight - 50) {
          setIsBottom(true);
        }
      }
    }, 2000);
  }, [show, contentRef.current]);

  const handleScroll = e => {
    // const { className, offsetHeight, scrollTop, scrollHeight } = e.target
    const {
      className,
      offsetHeight,
      scrollTop,
      scrollHeight
    } = contentRef.current;

    if (className && className.indexOf('c-tabContent') > -1 && offsetHeight + scrollTop > scrollHeight - 50) {
      setIsBottom(true);
    }
  };

  const cls = cs('c-supervisionPopup-bottom-bubble', {
    noTip: !((_dataSource$value = dataSource[value]) !== null && _dataSource$value !== void 0 && _dataSource$value.specialDesc.enable)
  });
  const clsTip = cs('c-supervisionPopup-bottom-tip', {});
  return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement(Popup, {
    visible: true,
    direction: "bottom",
    id: id,
    destroy: true,
    mountContainer: () => document.body
  }, /*#__PURE__*/React.createElement(GlobalStyled, null), /*#__PURE__*/React.createElement("div", {
    ref: box,
    className: `popup-box ${visible ? '' : 'no-visible'}`
  }, /*#__PURE__*/React.createElement(Tabs, {
    disabled: disabled,
    value: value,
    onChange: v => {
      setValue(v);
      changeTab(v);
    },
    scrollThreshold: 3
  }, dataSource && dataSource.map((item, index) => /*#__PURE__*/React.createElement(Panel, {
    key: item.title,
    title: /*#__PURE__*/React.createElement(Title, null, item.title)
  }, item.style === 'content' && value === index && /*#__PURE__*/React.createElement(TabContent, {
    ref: contentRef,
    onScroll: handleScroll,
    content: item.content,
    style: {
      paddingBottom: '70'
    }
  }), item.style === 'list' && /*#__PURE__*/React.createElement(TabList, {
    ref: contentRef,
    tabValue: value,
    list: item.list
  })))), /*#__PURE__*/React.createElement("div", {
    className: "c-supervisionPopup-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: cls
  }, /*#__PURE__*/React.createElement(BubbleTip, {
    attrs: (_dataSource$value2 = dataSource[value]) === null || _dataSource$value2 === void 0 ? void 0 : _dataSource$value2.tooltip,
    tabIndex: value
  })), ((_dataSource$value3 = dataSource[value]) === null || _dataSource$value3 === void 0 ? void 0 : _dataSource$value3.specialDesc.enable) && /*#__PURE__*/React.createElement("div", {
    className: clsTip
  }, /*#__PURE__*/React.createElement(ConfirmTip, {
    text: (_dataSource$value4 = dataSource[value]) === null || _dataSource$value4 === void 0 ? void 0 : _dataSource$value4.specialDesc.value[0]
  })), /*#__PURE__*/React.createElement("div", {
    className: "c-supervisionPopup-bottom-button"
  }, visible ? /*#__PURE__*/React.createElement("div", {
    className: "c-confirmButton-component 456"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "confirmButton",
    block: true,
    theme: "primary",
    onClick: handleClose
  }, buttonText)) :
  /*#__PURE__*/
  // <ConfirmButton onClick={btnClick} text={buttonText} />
  React.createElement(CountDownBtn, {
    ref: countRef,
    isBottom: isBottom,
    countDown: 10,
    onClick: btnClick,
    text: buttonText,
    dataSource: dataSource,
    value: value,
    setValue: setValue,
    changeTab: changeTab,
    disabled: disabled,
    setDisabled: setDisabled,
    setOuterTime: setOuterTime
  }))))));
};

export default SupervisionPopup;
const GlobalStyled = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;